import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.CustomPricePoint.ChangedPricesFromExcel.IRequest;
type Headers = Api.Core.CustomPricePoint.ChangedPricesFromExcel.IHeaders;
type Response = Api.Core.CustomPricePoint.ChangedPricesFromExcel.IResponse;
const url = '/api/ProductManagement/CustomPricePoint/ChangedPricesFromExcel/:productId';
export async function customPricePointChangedPricesFromExcelApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    body,
    url: createPathFromRoute(url, { productId: body.productId }, null),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
